import { WithAlert } from '@components/design';
import { feedback } from '@ecosystem/newron-design-system';

const { ActionType } = feedback;

export const NoResult = () => {
  return (
    <div className="my-4">
      <WithAlert
        title="No results available for the options selected. Try adjusting some filters."
        type="info"
        actionType={ActionType.DEFAULT}
      />
    </div>
  );
};
